import React from 'react';
import StarRating from '../StarRating/StarRating';
import QuickView from '../QuickView/QuickView';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import { captureTicker, isNumber } from './util';
import { endOfMonth, endOfQuarter } from '../FundList/util';
import styles from './style.css';
import { mapFundAllocation } from '../../hooks/useCartDetailsState';
import { distributeRemainder } from '../../core/util';

const RDFFundList = ({
  sortedFunds,
  next,
  openedQuickViewFund = {},
  setOpenedQuickViewFund
}) => {
  return (
    <div className="fund-list-wrapper" data-name="rdfFundListWrapper">
      <table className="fund-list">
        <thead>
          <tr className="header-row">
            <th className="table-header top returns sort">Fund name</th>
            <th className="table-header top returns sort">
              Overall Morningstar Rating
              <br />
              as of {endOfQuarter()}
            </th>
            <th className="table-header top returns">Morningstar Category</th>
            <th colSpan="3">
              <span className="fund-comp">
                Fund Composition as of
                <br />
                {endOfMonth()}
              </span>
              <hr />
              <table>
                <thead>
                  <tr>
                    <th className="table-header inside">Stocks</th>
                    <th className="table-header inside">Bonds</th>
                    <th className="table-header inside">Short-term</th>
                  </tr>
                </thead>
              </table>
            </th>
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <th className="table-header top returns">&nbsp;</th>
          </tr>
        </thead>

        <tbody>
          {sortedFunds.map((fund, index) => {
            const { allocation } = mapFundAllocation(fund);
            const {
              stocks,
              bonds,
              shortTermReserves,
              fundAllocationsPresent
            } = allocation;
            let roundedStocks = '-';
            let roundedBonds = '-';
            let roundedShortTerm = '-';
            if (fundAllocationsPresent) {
              [
                roundedStocks,
                roundedBonds,
                roundedShortTerm
              ] = distributeRemainder([stocks, bonds, shortTermReserves], 100);
            }
            const thisTicker = fund.ticker;
            const stocksComposition = isNumber(roundedStocks)
              ? `${roundedStocks}%`
              : roundedStocks;
            const bondsComposition = isNumber(roundedBonds)
              ? `${roundedBonds}%`
              : roundedBonds;
            const shortTermsComposition = isNumber(roundedShortTerm)
              ? `${roundedShortTerm}%`
              : roundedShortTerm;
            const fundItem = [
              <tr key={fund.index} className="fund-row">
                <td className="rdf-fund-names">
                  <MFBeaconButton
                    id="fundNameBtn"
                    data-name="fundNameBtn"
                    type="button"
                    tabIndex={0}
                    variant="tertiary"
                    onClick={() => {
                      setOpenedQuickViewFund(
                        captureTicker(thisTicker, openedQuickViewFund)
                      );
                    }}
                    onKeyDown={() => {
                      setOpenedQuickViewFund(
                        captureTicker(thisTicker, openedQuickViewFund)
                      );
                    }}
                    label={`${fund.name} (${fund.ticker})`}
                  />
                </td>
                <td>
                  {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`https://www.troweprice.com/personal-investing/tools/fund-research/${fund.ticker}`}>
                    <StarRating
                      numOfStars={5}
                      rating={
                        fund?.morningStarRatings?.morningStarOverallRating
                      }
                    />
                  </a>
                  {fund?.morningStarRatings?.morningStarOverallQuantity > 0 && (
                    <span>
                      (out of{' '}
                      {fund?.morningStarRatings?.morningStarOverallQuantity}{' '}
                      funds)
                    </span>
                  )}
                </td>
                <td>{fund?.morningStarRatings?.morningStarCategoryName}</td>
                <td>{stocksComposition}</td>
                <td>{bondsComposition}</td>
                <td>{shortTermsComposition}</td>
                <td className="rdf-funds-select-btn">
                  <MFBeaconButton
                    variant="primary"
                    size="normal"
                    id="addRDFtoCart"
                    onClick={next({
                      investmentMethod: 'BYOP',
                      fund: {
                        trpCode: fund.trpCode,
                        ticker: fund.ticker
                      }
                    })}
                    label="Select fund"
                  />
                </td>
              </tr>
            ];

            if (openedQuickViewFund[thisTicker]) {
              fundItem.push(
                <tr>
                  <td colSpan="100">
                    <QuickView
                      fund={fund}
                      id={`fundQV${index}`}
                      onClose={() =>
                        setOpenedQuickViewFund(
                          captureTicker(thisTicker, openedQuickViewFund)
                        )
                      }
                    />
                  </td>
                </tr>
              );
            }

            return fundItem;
          })}
        </tbody>
      </table>
      <style jsx>{styles}</style>
    </div>
  );
};

export default RDFFundList;
